import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { confidenceIndice } from '../../static-data';

interface ConfidenceSegmentsProps {
  /** Confidence level 0-5 (0 = not assessed). */
  level: number;
  /** Show the textual label (e.g. "Medium") next to the bar. */
  showLabel?: boolean;
  /** Narrower segments for tight spaces (e.g. the sidebar). */
  compact?: boolean;
}

const UNFILLED = '#e7e9ef';

/**
 * 5-segment confidence indicator (from the "Ipop Tools — Improved" design),
 * replacing the single-color dot. Filled segments use the level's color from
 * the shared `confidenceIndice` map so it stays consistent app-wide.
 */
export const ConfidenceSegments: FC<ConfidenceSegmentsProps> = ({ level = 0, showLabel = false, compact = false }) => {
  const { t } = useTranslation();
  const color = level > 0 ? confidenceIndice[level]?.['color'] : UNFILLED;

  return (
    <span style={{ display: 'inline-flex', gap: compact ? 2 : 3, alignItems: 'center', verticalAlign: 'middle' }}>
      {[1, 2, 3, 4, 5].map((i) => (
        <span
          key={i}
          style={{
            width: compact ? 6 : 14,
            height: compact ? 4 : 6,
            borderRadius: 2,
            display: 'inline-block',
            background: i <= level ? color : UNFILLED,
          }}
        />
      ))}
      {showLabel && level > 0 && (
        <span style={{ fontSize: 11, fontWeight: 600, marginLeft: 6, color }}>
          {t(confidenceIndice[level]['label'])}
        </span>
      )}
    </span>
  );
};
